import {parseInt} from 'lodash-es';
import {takeLatest, call, fork, put, all} from 'redux-saga/effects';

import {
  AnnotationApi,
  AssignmentApi,
  ConstructedResponseAnswerApi,
  ReadingSessionApi,
  StudentQuizApi,
} from 'static/three-oh/src/modules/apis';
import {startOfLastSchoolYear} from 'static/three-oh/src/modules/utils/dateHelpers';

import {studentBinderActions as actions} from '../actions';
import {studentBinderActionTypes} from '../constants';


function * getStudentQuizzes(studentId, lastSchoolYearStartDate) {
  const parameters = {
    student_id: studentId,
    date_start: lastSchoolYearStartDate,
  };
  return yield call(StudentQuizApi.get, parameters);
}

function * getStudentWriteResponses(studentId, lastSchoolYearStartDate) {
  const parameters = {
    student_id: studentId,
    modified_since: lastSchoolYearStartDate,
  };
  return yield call(ConstructedResponseAnswerApi.get, parameters);
}

function * getAssignments(lastSchoolYearStartDate) {
  const parameters = {
    date_start: lastSchoolYearStartDate,
  };
  return yield call(AssignmentApi.get, parameters);
}

function * getReadingSessions(userId, lastSchoolYearStartDate) {
  const parameters = {
    user_id: userId,
    date_start: lastSchoolYearStartDate,
  };
  return yield call(ReadingSessionApi.get, parameters);
}

function * getAnnotations(userId, lastSchoolYearStartDate) {
  const parameters = {
    user_id: userId,
    modified_since: lastSchoolYearStartDate,
  };
  return yield call(AnnotationApi.get, parameters);
}

function * getStudentBinderData(userId, studentId) {
  try {
    // only requesting quizzes, write responses, and assignments within this or last school year
    const lastSchoolYearStartDate = startOfLastSchoolYear().toISOString();
    yield put(actions.getStudentBinderDataRequest());
    const [annotations, readingSessions, studentQuizzes, studentWriteResponses, studentAssignments] = yield all([
      call(getAnnotations, userId, lastSchoolYearStartDate),
      call(getReadingSessions, userId, lastSchoolYearStartDate),
      call(getStudentQuizzes, studentId, lastSchoolYearStartDate),
      call(getStudentWriteResponses, studentId, lastSchoolYearStartDate),
      call(getAssignments, lastSchoolYearStartDate)
    ]);

    const payload = {
      studentId: studentId,
      studentQuizzes: studentQuizzes,
      writeResponses: studentWriteResponses,
      annotations: annotations,
      studentAssignments: studentAssignments,
      readingSessions: readingSessions,
    };
    yield put(actions.getStudentBinderDataSuccess(payload));
  } catch (error) {
    yield put(actions.getStudentBinderDataFailure(error));
  }
}

export function * watchInitStudentBinder() {
  yield takeLatest(studentBinderActionTypes.INITIALIZE_STUDENT_BINDER, function * init(action) {
    const userId = parseInt(action.payload.userId);
    const studentId = parseInt(action.payload.studentId);
    const classroomIds = action.payload.classroomIds;
    yield fork(getStudentBinderData, userId, studentId, classroomIds);
  });
}
